import Api from "./Base";

export function fetchCommunity(data) {
    return Api.get("/community", data);
}
